import { Container } from "react-bootstrap";
import CollapsibleCard from "./site/CollapsibleCard";
import AxpoInvoicesCard from "./dataconfig/AxpoInvoicesCard";
import DailyReportsCard from "./dataconfig/DailyReportsCard";
import DocumentNumbersCard from "./dataconfig/DocumentNumbersCard";
import ExportAllSitesCard from "./dataconfig/ExportAllSitesCard";
import GlobalStateCard from "./dataconfig/GlobalStateCard";
import LandlordResearchPromptCard from "./dataconfig/LandlordResearchPromptCard";
import OutreachEmailPromptCard from "./dataconfig/OutreachEmailPromptCard";
import PeopleRankingPromptCard from "./dataconfig/PeopleRankingPromptCard";
import PVSummaryCard from "./dataconfig/PVSummaryCard";
import SurveyEndpointsCard from "./dataconfig/SurveyEndpointsCard";
import VoaDataLoadedCard from "./dataconfig/VoaDataLoadedCard";

const DataConfig = () => {
  document.title = "Data & Config";

  return (
    <Container
      fluid
      className="d-flex flex-column gap-3"
      style={{ padding: "12px 12px 32px 12px", fontSize: 14 }}
    >
      <DocumentNumbersCard />
      <SurveyEndpointsCard />
      <GlobalStateCard />
      <AxpoInvoicesCard />
      <PVSummaryCard />
      <DailyReportsCard />
      <ExportAllSitesCard />
      <VoaDataLoadedCard />
      <CollapsibleCard
        title="Leads prompts"
        initialOpen={false}
        isWrapper
        className="leads-prompts-wrapper"
      >
        <LandlordResearchPromptCard />
        <PeopleRankingPromptCard />
        <OutreachEmailPromptCard />
      </CollapsibleCard>
    </Container>
  );
};

export default DataConfig;
